<template>
  <v-container fluid>
  <v-layout>
    <v-flex xs12>
     <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="6000"
        absolute
        >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-layout row pb-1 mb-1>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-btn rounded small color="primary" @click="generateEslip" :disabled="canGenerateEslip || processingRequest"> Generate ESlip </v-btn>
            <v-progress-linear v-if="showProgressBar" indeterminate></v-progress-linear>
          </v-flex>
      </v-layout>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="invoices"
        show-select
        class="elevation-1"
      >
      <template v-slot:item.created="{ item }">
         {{item.dateCreated | prettyDate }}
      </template>
      </v-data-table>
    </v-flex>
    <v-dialog v-model="rejectDialog" max-width="600">
      <v-card>
        <v-card-title>
          <h3 class="primary--text"> Reject Invoice </h3>
        </v-card-title>
        <v-card-text>
          <p class="text"> Confirm invoice rejection for {{ rejectInvoice.marketer.organisationName }} amount {{ rejectInvoice.totalValue }} ? </p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="white" @click="closeInvoiceDialog"> Close </v-btn>
          <v-spacer> </v-spacer>
          <v-btn color="secondary" @click="rejectInvoiceFunction"> Reject </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
  </v-layout>
  </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'

  export default {
    name: 'buyerinvoices',
    data: function () {
      return {
        headers: [
          { text: 'Invoice Id', value: 'id' },
          { text: 'Payable To', value: 'marketer.organisationName' },
          { text: 'Invoice Amount', value: 'invoiceAmount' },
          { text: 'Number Of Bags', value: 'totalNumberOfBags' },
          { text: 'Total Weight', value: 'totalWeight' },
          { text: 'Invoice Status', value: 'status.statusName' },
          { text: 'Invoice Date', value: 'created' }
        ],
        invoices: [],
        data: [],
        message: '',
        error: '',
        loading: false,
        pagination: {
          sortBy: 'name'
        },
        totalInvoices: 0,
        snackbar: false,
        snackbarColor: '',
        messsage: '',
        editedItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        defaultItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        selected: [],
        rejectInvoice: { marketer: {}, totalValue: '' },
        rejectDialog: false,
        processingRequest: false,
        showProgressBar: false
      }
    },
    mounted () {
      this.getDataFromApi()
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              // this.users = data.items
              // this.totalUsers = data.total
            })
        },
        deep: true
      }
    },
    // computed: {
    //   canGenerateEslip: function () {
    //     if (this.selected.length > 0) {
    //       return false
    //     } else {
    //       return true
    //     }
    //   }
    // },
    computed: {
      canGenerateEslip: function () {
        if (this.selected.length === 0 || this.processingRequest) {
          return true // Disable the button if nothing is selected or a request is being processed
        } else {
          return false // Enable the button if there are selected records and no request is being processed
        }
      }
    },
    methods: {
      rejectInvoiceDialog (item) {
        this.rejectDialog = true
        this.rejectInvoice = item
      },
      closeInvoiceDialog () {
        this.rejectInvoice = { marketer: {}, totalValue: '' }
        this.rejectDialog = false
      },
      rejectInvoiceFunction () {
        const url = config.serverURI + '/invoice/reject'
        axios.post(url, this.rejectInvoice)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.invoices = this.getBuyerInvoices()
            this.message = response.data.message
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
        this.closeInvoiceDialog()
      },
      requestEslipDialog (item) {
        this.editedIndex = this.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        this.sendRequest()
        this.close()
      },
      sendRequest () {
        const url = config.serverURI + '/invoice/requesteslip'
        axios.post(url, this.editedItem)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.invoices = this.getBuyerInvoices()
            this.message = response.data.message
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
      },
      getDataFromApi () {
        this.loading = true
        return new Promise((resolve, reject) => {
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let items = this.getBuyerInvoices()
          const total = items.length

          if (this.pagination.sortBy) {
            items = items.sort((a, b) => {
              const sortA = a[sortBy]
              const sortB = b[sortBy]

              if (descending) {
                if (sortA < sortB) return 1
                if (sortA > sortB) return -1
                return 0
              } else {
                if (sortA < sortB) return -1
                if (sortA > sortB) return 1
                return 0
              }
            })
          }

          if (rowsPerPage > 0) {
            items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
          }

          setTimeout(() => {
            this.loading = false
            resolve({
              items,
              total
            })
          }, 1000)
        })
      },
      toggleSelect (props) {
        // eslint-disable-next-line
        if (props.item.statusId == 4) {
          props.selected = !props.selected
        }
      },
      getBuyerInvoices () {
        var url = config.serverURI + '/invoice/buyer/invoices'
        axios.get(url)
          .then(response => {
            console.log('Respnse', response.data)
            // this.invoices = response.data
            // this.invoices = this.data.filter(invoice => invoice.status.id === 4)
            this.invoices = response.data.filter(
              invoice => invoice.status.id === 4
            )
            console.log('invoices', this.invoices)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.message = error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
          })
        return this.data
      },
      toggleAll () {
        if (this.selected.length) {
          this.selected = []
        } else {
          const result = this.data.filter(sel => {
            // eslint-disable-next-line
            return sel.status.id == 1
          })
          this.selected = result.slice()
        }
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      generateEslip () {
        this.processingRequest = true
        this.showProgressBar = true
        console.log(this.selected)
        this.sendGenerateEslipRequest()
      },
      getCount (items, id) {
        let count = 0
        for (var i = 0; i < items.length; i++) {
          if (items[i].marketerId=== id && items[i].statusId === 4) {
            count++
          }
        }
        return count
      },
      // sendGenerateEslipRequest () {
      //   // validate if buyer has selected all invoices
      //   // count for particular marketer id
      //   const selectedmarketers = this.selected.flatMap(x => [x.marketer.id])
      //   for (var i = 0; i < selectedmarketers.length; i++) {
      //     const countInSelected = this.getCount(this.selected, selectedmarketers[i])
      //     const countInAll = this.getCount(this.invoices, selectedmarketers[i])
      //     console.log(countInAll + ' ' + countInSelected)
      //     if (countInSelected !== countInAll || countInAll === 0) {
      //       this.snackbar = true
      //       this.message = 'All pending invoices should be selected, selected are ' + countInSelected + ', out of ' + countInAll
      //       this.snackbarColor = 'error'
      //       this.showProgressBar = false
      //       this.processingRequest = false
      //       return false
      //     }
      //   }
      sendGenerateEslipRequest() {

  const pendingInvoices = this.data.filter(
    x => x.status.statusName === 'PENDING_ESLIP'
  );

  const selectedmarketers = [...new Set(
    this.selected.map(x => x.marketer.id)
  )];

  for (let i = 0; i < selectedmarketers.length; i++) {

    const marketerId = selectedmarketers[i];

    const countInSelected = this.getCount(this.selected, marketerId);
    const countInAll = this.getCount(pendingInvoices, marketerId);

    console.log(countInAll + ' ' + countInSelected);

    if (countInSelected !== countInAll ) {
      this.snackbar = true;
      this.message = `All pending invoices should be selected, selected are ${countInSelected}, out of ${countInAll}`;
      this.snackbarColor = 'error';
      this.showProgressBar = false;
      this.processingRequest = false;
      return false;
    }
  }
        const url = config.serverURI + '/eslip/request'
        axios.post(url, this.selected)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              this.selected = []
              // return
            } else {
              this.message = response.data.message
              this.snackbarColor = 'primary'
              this.selected = []
            // this.getBuyerInvoices()
            }
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
          .finally(() => {
            this.showProgressBar = false
            this.processingRequest = false
            this.getBuyerInvoices()
          })
      },
      triggerDownload (item) {
        var url = config.serverURI + '/invoice/download/' + item.id
        axios.get(url)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const itemFileName = item.marketerName + '_' + item.created
            link.setAttribute('download', itemFileName)
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.message = error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
          })
        return this.data
      }
    }
  }

  </script>
  <style>
  .text {
    font-style: 'Open Sans';
    font-size: 16px;
    color: #000;
  }
  </style>
